import { useCallback } from "react";
import { useAuthContext } from "../auth-context.js";
export function useAuth() {
    const { isAuthenticated, isLoading, isInitializing, user, error, login, loginWithPassword, logout, refreshSession, } = useAuthContext();
    const isSessionExpiringSoon = useCallback((_thresholdMs = 5 * 60 * 1000) => {
        // Session expiry is managed server-side via cookies
        // This hook provides a way to proactively refresh if needed
        return false;
    }, []);
    const hasPermission = useCallback((permission) => {
        return user?.permissions.includes(permission) ?? false;
    }, [user]);
    const hasEntitlement = useCallback((mfeId) => {
        return user?.entitlements.includes(mfeId) ?? false;
    }, [user]);
    const hasRole = useCallback((role) => {
        return user?.role === role;
    }, [user]);
    const isAdmin = useCallback(() => {
        return user?.role === "admin" || user?.role === "owner";
    }, [user]);
    return {
        isAuthenticated,
        isLoading,
        isInitializing,
        user,
        error,
        login,
        loginWithPassword,
        logout,
        refreshSession,
        isSessionExpiringSoon,
        hasPermission,
        hasEntitlement,
        hasRole,
        isAdmin,
    };
}
//# sourceMappingURL=useAuth.js.map